require('../../../modules/es.array.map');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').map;